import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormKeys, MarketplaceFormValues } from '../types';

export const CostPerShareField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const currency = watch(MarketplaceFormKeys.currency);

  return (
    <TextField
      placeholder="3.5"
      rightSection={t(currency)}
      help={t('Tooltip.Cost Share Help')}
      title={t('TextForm.Cost per Share')}
      name={MarketplaceFormKeys.costPerShare}
      {...props}
    />
  );
};
